import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Global promo status cache (module-level, dedupes across mounts). */
let _cache = null;
let _inflight = null;

async function fetchStatus() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = api.get("/promo/status").then((r) => {
    _cache = r.data;
    _inflight = null;
    return _cache;
  }).catch(() => {
    _inflight = null;
    return { active: false };
  });
  return _inflight;
}

/**
 * Hook: returns { active, end_date, days_remaining, label_fr, label_en, loading }.
 * Fetches once per session, cached in module scope.
 */
export function usePromoStatus() {
  const [state, setState] = useState({ ..._cache, loading: !_cache });
  useEffect(() => {
    let mounted = true;
    if (_cache) return;
    fetchStatus().then((s) => {
      if (mounted) setState({ ...s, loading: false });
    });
    return () => { mounted = false; };
  }, []);
  return state;
}
